// extracted by mini-css-extract-plugin
export default {"firstBlock":"style_firstBlock__E-i1s","textDiv":"style_textDiv__yEQL+","image":"style_image__swePo","btnDiv":"style_btnDiv__6Ftxp","btn":"style_btn__pH97O"};